// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardlayout{
    display: flex;
    max-width: 100%;
    height: 100vh;
}
.dashboardlayout_content{
    position: relative;
    overflow-y: auto;
    width: 100%;
    padding: 20px 40px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.dashboardlayout_header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    padding: 5px 0;
    position: relative;
}

.dashboardlayout_history{
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 20px;
}

.dashboardlayout_historyButton{
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 10px;
}

.dashboardlayout_historyBack{
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
}

.dashboardlayout_historyBack:hover{
    background-color: #F2F3FC;
}

.dashboardlayout_historyBack img{
    transform: rotate(90deg);
}

.dashboardlayout_historyNext{
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
}

.dashboardlayout_historyNext:hover{
    background-color: #F2F3FC;
}

.dashboardlayout_historyNext img{
    transform: rotate(-90deg);
}

.dashboardlayout_title{
    margin: 0;
    color: #475467;
    font-style: italic;
}

.dashboardlayout_traduction{
    background-color: #F2F3FC;
    padding: 12px 30px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 12px;
}

.dashboardlayout_traduction img{
    height: 8px;
    width: 8px;
}

.dashboardlayout_traductionModal{
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    background-color: #F2F3FC;
    width: 124px;
    overflow-y: hidden;
    border-radius: 10px;
    max-height: 0;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    transition: max-height 0.3s ease-in-out;
}

.dashboardlayout_traductionModalOpen{
    max-height: 300px;
    opacity: 1;
    padding: 10px;
    z-index: 2;
}

.dashboardlayout_traductionListe{
    display: flex;
    flex-direction: column;
    gap: 5px;
    overflow-y: auto;
    height: 100%;
}

.dashboardlayout_traductionItem{
    margin: 0;
    cursor: pointer;
    border-radius: 8px;
    max-width: 100%;
    padding: 10px 0 10px 20px;
    font-size: 12px;
}

.dashboardlayout_traductionItem:hover{
    background-color: #fff;
}

/******************* MODAL TOASTER ***********************/

.toaster{
    border-radius: 10px;
    padding: 10px 20px;
    width: 350px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.toaster-component {
    min-width: 90%;
    max-width: 100%;
    position: absolute;
    top: 0;
}

.toaster-relative{
    position: relative;
    display: flex;
    justify-content: center;
    padding-top: 20px;
}

.error-toaster{
    background-color: #FEEFEF;
    color: #F44336;
    border: solid 1px #F44336;
}

.loading-toaster{
    background-color: #F2F3FC;
    color: #475467;
    border: solid 1px #475467;
}

.response-toaster{
    background-color: #F2F3FC;
    color: #2B64F5;
    border: solid 1px #2B64F5;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/dashboard/dashboardLayout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,0DAA0D;;AAE1D;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B","sourcesContent":[".dashboardlayout{\n    display: flex;\n    max-width: 100%;\n    height: 100vh;\n}\n.dashboardlayout_content{\n    position: relative;\n    overflow-y: auto;\n    width: 100%;\n    padding: 20px 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.dashboardlayout_header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 100%;\n    padding: 5px 0;\n    position: relative;\n}\n\n.dashboardlayout_history{\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 20px;\n}\n\n.dashboardlayout_historyButton{\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 10px;\n}\n\n.dashboardlayout_historyBack{\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n}\n\n.dashboardlayout_historyBack:hover{\n    background-color: #F2F3FC;\n}\n\n.dashboardlayout_historyBack img{\n    transform: rotate(90deg);\n}\n\n.dashboardlayout_historyNext{\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n}\n\n.dashboardlayout_historyNext:hover{\n    background-color: #F2F3FC;\n}\n\n.dashboardlayout_historyNext img{\n    transform: rotate(-90deg);\n}\n\n.dashboardlayout_title{\n    margin: 0;\n    color: #475467;\n    font-style: italic;\n}\n\n.dashboardlayout_traduction{\n    background-color: #F2F3FC;\n    padding: 12px 30px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.dashboardlayout_traduction img{\n    height: 8px;\n    width: 8px;\n}\n\n.dashboardlayout_traductionModal{\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform: translateY(100%);\n    background-color: #F2F3FC;\n    width: 124px;\n    overflow-y: hidden;\n    border-radius: 10px;\n    max-height: 0;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n    transition: max-height 0.3s ease-in-out;\n}\n\n.dashboardlayout_traductionModalOpen{\n    max-height: 300px;\n    opacity: 1;\n    padding: 10px;\n    z-index: 2;\n}\n\n.dashboardlayout_traductionListe{\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    overflow-y: auto;\n    height: 100%;\n}\n\n.dashboardlayout_traductionItem{\n    margin: 0;\n    cursor: pointer;\n    border-radius: 8px;\n    max-width: 100%;\n    padding: 10px 0 10px 20px;\n    font-size: 12px;\n}\n\n.dashboardlayout_traductionItem:hover{\n    background-color: #fff;\n}\n\n/******************* MODAL TOASTER ***********************/\n\n.toaster{\n    border-radius: 10px;\n    padding: 10px 20px;\n    width: 350px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.toaster-component {\n    min-width: 90%;\n    max-width: 100%;\n    position: absolute;\n    top: 0;\n}\n\n.toaster-relative{\n    position: relative;\n    display: flex;\n    justify-content: center;\n    padding-top: 20px;\n}\n\n.error-toaster{\n    background-color: #FEEFEF;\n    color: #F44336;\n    border: solid 1px #F44336;\n}\n\n.loading-toaster{\n    background-color: #F2F3FC;\n    color: #475467;\n    border: solid 1px #475467;\n}\n\n.response-toaster{\n    background-color: #F2F3FC;\n    color: #2B64F5;\n    border: solid 1px #2B64F5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
